export default __webpack_public_path__ + "static/media/ourstory3.7a4d024f.jpg";